<template>
    <nav> 
        <ul class="top-nav" id="dropdownClick">
            <li class="home top-nav-left"><a href="/" class="link" @click.prevent="$router.push('/')"><i class="fa-solid fa-house"></i></a></li>
            <li><router-link to="/contact" class="link" active-class="active-link">Contact Me</router-link></li>
            <li><router-link to="/achievements" class="link" active-class="active-link">Certifications</router-link></li>
            <li><router-link to="/blog" class="link" active-class="active-link">Blog</router-link></li>
            <li><router-link to="/portfolio" class="link" active-class="active-link" >Portfolio</router-link></li>
            <li class="menu menuIcon"><a href="javascript:void(0);" class="link" @click.prevent=dropdownMenu()><i class="fa-solid fa-bars" style="color: #ffffff;"></i></a></li>
        </ul>
    </nav>
</template>

<script>

export default {
    name: 'NavBar',
    methods: {
        dropdownMenu(){
            let dropdown = document.getElementById("dropdownClick");
            if( dropdown.className === "top-nav"){
                dropdown.className += " responsive";
            } else{ 
                dropdown.className = "top-nav";
            }
        }   
    }
}
</script>


<style scoped>
@import '@fortawesome/fontawesome-free/css/all.css';

nav {
    display: block;
    width: 100%;
    margin: 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

nav ul {
    background-color: #007BFF;
    overflow: hidden;
    margin: 0;
    padding: 0;

}

nav ul li{
    list-style-type: none;
}

ul.top-nav li{
    list-style: none;
    float: right;
}

ul.top-nav li.top-nav-left {
    float: left;
}

.link{
    display: block;
    text-decoration: none;
    font-size: 16px;
    text-align: center;
    padding: 16px;
}

ul.top-nav li.menuIcon{
    display: none;
}

/* /* .home a, .link {
    background-color: transparent; 
} */


/* .links {
    display: flex;
    justify-content: space-between;
} */

/* .link {
    margin-right: 20px;
} */

.link, .link:active, .link:hover, .active-link {
    color: white;  /* Default color for links */
    text-decoration: none;
    transition: color 0.3s;
}


.home a:hover, .link:hover, .active-link {
    color: #ccc;
}

/* Mobile */

@media screen and (max-width: 745px) {

    ul.top-nav li:not(:nth-child(1)) {
        display: none;
    }

    ul.top-nav li.menuIcon{
        display: block;
    }

    ul.top-nav.responsive li.menuIcon{
        position: absolute;
        top: 0;
        right: 0;
    }

    ul.top-nav.responsive{
        position: relative;
    }

    ul.top-nav.responsive li{
        display: inline;
        float: none;
    }

    ul.top-nav.responsive .link {
        display: block;
        text-align: left;
        padding: 16px;
    }

    .menuIcon a:hover {
        color: #ccc;

    }

}


</style>
